var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"mt-5",attrs:{"elevation":"0"}},[_c('v-card-title',[_vm._v("Tags")]),_c('v-divider'),_c('v-chip-group',{attrs:{"column":""}},_vm._l((_vm.list),function(item){return _c('v-chip',{key:item.id,attrs:{"outlined":""}},[_vm._v(_vm._s(item.name))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }